import { render, staticRenderFns } from "./TeacherTable.vue?vue&type=template&id=51bd6dc0"
import script from "./TeacherTable.vue?vue&type=script&lang=js"
export * from "./TeacherTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports